import { XCircle } from "lucide-react";
import Reveal, { SectionHead } from "./Reveal";

const LIES = [
  "“This church may no longer be active.”",
  "“I cannot tell what they believe.”",
  "“I do not know what to expect if I visit.”",
  "“There is no clear way to ask for prayer, get help, or connect.”",
  "“Their ministry may not be for people like me.”",
  "“I will keep scrolling.”",
];

export default function Stakes() {
  return (
    <section id="stakes" data-testid="stakes-section" className="py-20 lg:py-32 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <SectionHead eyebrow="The Stakes" title="Digital Invisibility Is a Ministry Problem."
          sub="A missing or neglected online presence can communicate things you never intended:" />
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="stakes-list">
          {LIES.map((lie, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <div className="h-full rounded-lg border border-crimson/40 bg-crimson/5 p-6 transition-all duration-300 hover:border-crimson hover:bg-crimson/10 hover:-translate-y-1">
                <XCircle className="text-crimson mb-4" size={22} />
                <p className="font-cormorant italic text-lg text-slate-200 leading-snug">{lie}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2}>
          <p className="mt-12 font-display text-xl sm:text-2xl uppercase tracking-tight gold-text" data-testid="stakes-turnaround">
            Minister of Social Media™ changes that story.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
